import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-suscripcion-boleta-satisfactoria',
  templateUrl: './suscripcion-boleta-satisfactoria.component.html',
  styleUrls: ['./suscripcion-boleta-satisfactoria.component.scss']
})
export class SuscripcionBoletaSatisfactoriaComponent implements OnInit {

  @Input() solicitud: string;
  @Input() codigo: string;
  @Input() mensaje: string;
  @Input() plazo: string;


  constructor() { }

  ngOnInit(): void {
  }

}
